import { render, staticRenderFns } from "./FieldsQuestion.vue?vue&type=template&id=fb1d8f80&scoped=true"
import script from "./FieldsQuestion.vue?vue&type=script&lang=js"
export * from "./FieldsQuestion.vue?vue&type=script&lang=js"
import style0 from "./FieldsQuestion.vue?vue&type=style&index=0&id=fb1d8f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1d8f80",
  null
  
)

export default component.exports